export interface UndoHistory<T> {
  readonly canUndo: boolean
  readonly canRedo: boolean
  record: (state: T) => void
  undo: () => T | undefined
  redo: () => T | undefined
}

export function createUndoHistory<T>(initial: T, limit = 100): UndoHistory<T> {
  const past: T[] = []
  const future: T[] = []
  let current = initial

  return {
    get canUndo() {
      return past.length > 0
    },
    get canRedo() {
      return future.length > 0
    },
    record(state) {
      past.push(current)
      if (past.length > limit) past.shift()
      future.length = 0
      current = state
    },
    undo() {
      const previous = past.pop()
      if (previous === undefined) return undefined
      future.push(current)
      current = previous
      return current
    },
    redo() {
      const next = future.pop()
      if (next === undefined) return undefined
      past.push(current)
      current = next
      return current
    },
  }
}
